export default "/images/bbd1cb06895e32b56614327a8e6305eb.avif";